import {
  GOOGLE_CALENDAR_EVENT_DETAILS,
  GOOGLE_CALENDAR_EVENT_TITLE
} from '../../constants/FormConstant';

import { convertISTToUTC, parseTimeSlot } from '../TimeParserUtils';

export const generateGoogleCalendarLink = (
  selectADateToBookASlot: string,
  timeSlots: string
): string => {
  let eventDate: Date;
  eventDate = new Date(selectADateToBookASlot);

  if (isNaN(eventDate.getTime())) {
    const dateParts = selectADateToBookASlot.split('-');
    if (dateParts.length === 3) {
      const [year, month, day] = dateParts;
      eventDate = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
    } else {
      throw new Error(`Invalid date format: ${selectADateToBookASlot}`);
    }
  }

  let endDate: Date;

  if (timeSlots) {
    const { startTime, endTime } = parseTimeSlot(timeSlots);

    eventDate.setHours(startTime.hours, startTime.minutes, 0, 0);

    endDate = new Date(eventDate);
    endDate.setHours(endTime.hours, endTime.minutes, 0, 0);

    if (
      endTime.hours < startTime.hours ||
      (endTime.hours === startTime.hours && endTime.minutes < startTime.minutes)
    ) {
      endDate.setDate(endDate.getDate() + 1);
    }
  } else {
    endDate = new Date(eventDate.getTime() + 60 * 60 * 1000);
  }

  if (isNaN(eventDate.getTime())) {
    throw new Error(`Invalid date: ${selectADateToBookASlot}`);
  }

  const formatDateForGoogleCalendar = (date: Date): string => {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, '0');
    const day = String(date.getUTCDate()).padStart(2, '0');
    const hours = String(date.getUTCHours()).padStart(2, '0');
    const minutes = String(date.getUTCMinutes()).padStart(2, '0');
    const seconds = String(date.getUTCSeconds()).padStart(2, '0');
    return `${year}${month}${day}T${hours}${minutes}${seconds}Z`;
  };

  const startUTC = convertISTToUTC(eventDate);
  const endUTC = convertISTToUTC(endDate);

  const startDateStr = formatDateForGoogleCalendar(startUTC);
  const endDateStr = formatDateForGoogleCalendar(endUTC);

  const baseUrl = 'https://calendar.google.com/calendar/render';
  const params = new URLSearchParams({
    action: 'TEMPLATE',
    dates: `${startDateStr}/${endDateStr}`,
    details: GOOGLE_CALENDAR_EVENT_DETAILS,
    location: '',
    text: GOOGLE_CALENDAR_EVENT_TITLE
  });

  return `${baseUrl}?${params.toString()}`;
};
